// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FormattedVolume(props) {
  let liters = props.milliliters / 1000.0;
  return React.cloneElement(<ReactIntl.FormattedNumber
    value={liters}
    minimumFractionDigits={1}
    maximumFractionDigits={1}
  >
    {props.children}
  </ReactIntl.FormattedNumber>, {
    style: "unit",
    unit: "liter"
  });
}

let make = FormattedVolume;

export {
  make,
}
/* react Not a pure module */
